import React from "react";
import Modal from "react-modal";
import { Title } from "./styled";
import { Container, Close, ContainerLegend, } from "./styled";
import { CalendarDaysIcon, CodeBracketIcon, CreditCardIcon, UserCircleIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from 'react-redux';
import { translations } from '../../../../utils/language';

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        width: "360px",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "white",
        padding: "0px",
        margin: "0px",
        borderRadius: "10px",
    },
    overlay: {
        backgroundColor: "rgba(10,23,55,0.5)",
        zIndex: "99999999",
    },
};

const ModalLicenca = (props) => {

    const [products, setProducts] = useState(null)
    const language = useSelector((state) => state.reducerLanguage);


    useEffect(() => {
        console.log("props_item", props.item)
        try {
            const raw = props.item?.order_items_codes
            setProducts(raw ? JSON.parse(raw) : [])
        } catch (e) {
            console.error('Erro ao parsear order_items_codes', e)
            setProducts([])
        }
    }, [props])

    useEffect(() => {
        console.log("products", products)
    }, [products])

    return (
        <Modal
            isOpen={props.visible}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() => { props.setVisibleModal(false) }}
        >
            <Container>
                {/* <Title marginBottom="16px">{"Produtos"}</Title> */}
                <Close onClick={() => props.setVisibleModal(false)}>X</Close>
                {/* <ContainerLegend></ContainerLegend> */}

                {products && products.map((product, index) => (
                    product.licenses.map((license, index) => (
                        <div key={index} className={`lg:col-start-3 lg:row-end-1 ${index !== product.licenses.length - 1 ? 'mb-4' : ''}`}>
                            <h2 className="sr-only">{translations["sales-licenca-resumo"][language.data]}</h2>
                            <div className="rounded-lg bg-gray-50 shadow-sm ring-1 ring-gray-900/5">
                                <dl className="flex flex-wrap">
                                    <div className="flex-auto pl-6 pt-6">
                                        <dt className="text-sm/6 font-semibold text-gray-900">{product.product.name}</dt>
                                        <dd className="mt-1 text-base font-semibold text-gray-900">{license.name}</dd>
                                    </div>
                                    <div className="flex-none self-end px-6 pt-4">
                                        <dt className="sr-only">{translations["Status"][language.data]}</dt>
                                        <dd className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                                            {translations["sales-status-enviado"][language.data]}
                                        </dd>
                                    </div>
                                    {license.codes.map((code, index) => (
                                        <div className="mt-6 flex w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pb-6 pt-6">
                                            <dt className="flex-none">
                                                <span className="sr-only">{translations["sales-licenca-cliente"][language.data]}</span>
                                                <CodeBracketIcon aria-hidden="true" className="h-6 w-5 text-gray-400" />
                                            </dt>
                                            <dd className="text-sm/6 font-medium text-gray-900">{code.serial_number}</dd>
                                        </div>
                                    ))}
                                </dl>
                            </div>
                        </div>
                    ))
                ))}
            </Container>
        </Modal>
    );
};

export default ModalLicenca;
